module.exports = __webpack_public_path__ + "img/sofa.89f585b1.png";